export default __webpack_public_path__ + "resources/icons/n440-1d74.webp";